<template>
  <div id="app">
    <router-view v-on:footer="footer"></router-view>
    <bottom v-if="footer_show"></bottom>
  </div>
</template>

<script>
import bottom from '@/components/bottom.vue'
export default {
  name: 'app',
  components: {
    bottom
  },
  data(){
    return{
      footer_show:true,
    }
  },
  methods:{
    //是否显示底部
      footer:function (bool) {
        this.footer_show = bool;
      }
  },
  watch:{
    $route(to){
      if(to.path==='/personinfo'||to.path==='/skills'||to.path==='/baseinfo'||to.path==='/addcase'||to.path==='/editcase'){
        this.footer_show=false
      }
    }
    
  }
}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// App.vue?fbf6f6a2